(function() {
  'use strict';

  // ============================================
  // CONSTANTES
  // ============================================
  const STORAGE_KEY = 'bigmad_recently_viewed';
  const MAX_ITEMS = 20;

  // ============================================
  // JUDGE.ME — força render em cards injetados via JS
  // ============================================
  function renderJudgemeBadges() {
    let attempts = 0;
    const maxAttempts = 15;

    function tryRender() {
      attempts++;

      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
        window.jdgm.customizeBadges();
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryRender, 300);
      }
    }

    tryRender();
  }

  // ============================================
  // VÍDEO NOS CARDS — anexa listeners nos cards injetados via JS
  // (com retry, caso o card JS ainda não tenha carregado)
  // ============================================
  function setupCardVideos() {
    if (window.bmsSetupCardVideos) {
      window.bmsSetupCardVideos();
    } else {
      setTimeout(() => { if (window.bmsSetupCardVideos) window.bmsSetupCardVideos(); }, 500);
    }
  }

  // ============================================
  // LOCALSTORAGE — leitura/escrita de vistos recentes
  // ============================================
  function getViewed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveViewed(handle) {
    if (!handle) return;
    try {
      let list = getViewed().filter(h => h !== handle);
      list.unshift(handle);
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // ============================================
  // TRACKING — se está em página de produto, salva o handle
  // ============================================
  function trackCurrentPage() {
    const match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (match && match[1]) {
      saveViewed(match[1].toLowerCase().trim());
    }
  }

  // Roda imediatamente
  trackCurrentPage();

  // ============================================
  // INIT — espera DOM carregar pra processar os sliders
  // ============================================
  function init() {
    const sections = document.querySelectorAll('.bigmad-slider-section');
    sections.forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============================================
  // SETUP — cada slider
  // ============================================
  function setupSlider(section) {
    const track = section.querySelector('[data-bms-track]');
    if (!track) return;

    const source = section.dataset.source;

    // Setup arrows + animação + botões sempre
    setupNavigation(section, track);
    setupAnimation(section);
    setupWheelScroll(track);

    // Carrega conteúdo dinâmico se necessário
    if (source === 'recently_viewed') {
      loadRecentlyViewed(section, track);
    } else if (source === 'recommendations') {
      loadRecommendations(section, track);
    } else {
      // Conteúdo já renderizado pelo Liquid (coleção/manual)
      setupAddButtons(section);
      // Vídeos dos cards renderizados pelo Liquid
      setupCardVideos();
    }
  }

  // ============================================
  // CARREGA VISTOS RECENTEMENTE
  // (usa o snippet Liquid bigmad-product-card via Section Rendering API)
  // ============================================
  async function loadRecentlyViewed(section, track) {
    const limit = parseInt(section.dataset.recentlyViewedLimit) || 6;
    let handles = getViewed();

    // Remove o produto atual da lista
    const currentMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (currentMatch && currentMatch[1]) {
      const currentHandle = currentMatch[1].toLowerCase().trim();
      handles = handles.filter(h => h !== currentHandle);
    }

    handles = handles.slice(0, limit);

    if (handles.length === 0) {
      section.style.display = 'none';
      return;
    }

    // Fetch dos cards renderizados pelo Liquid (snippet bigmad-product-card)
    // Usa /products/{handle}?section_id=bigmad-card-fragment pra pegar o HTML pronto
    const htmlPromises = handles.map(handle =>
      fetch(`/products/${handle}?section_id=bigmad-card-fragment`)
        .then(r => r.ok ? r.text() : null)
        .catch(() => null)
    );

    const htmls = (await Promise.all(htmlPromises)).filter(h => h !== null);

    if (htmls.length === 0) {
      section.style.display = 'none';
      return;
    }

    // Extrai só o <article class="bms-card"> de cada response
    const parser = new DOMParser();
    const cards = htmls.map(html => {
      const doc = parser.parseFromString(html, 'text/html');
      const card = doc.querySelector('.bms-card');
      return card ? card.outerHTML : '';
    }).filter(c => c !== '');

    if (cards.length === 0) {
      section.style.display = 'none';
      return;
    }

    track.innerHTML = cards.join('');
    setupAddButtons(section);
    section.classList.add('is-visible');

    // Força Judge.me a renderizar nos cards novos
    renderJudgemeBadges();

    // Anexa os vídeos nos cards recém-injetados
    setupCardVideos();
  }

  // ============================================
  // CARREGA RECOMENDADOS
  // ============================================
    async function loadRecommendations(section, track) {
    const productId = section.dataset.productId;
    const limit = parseInt(section.dataset.recommendationsLimit) || 6;

    if (!productId) {
      section.style.display = 'none';
      return;
    }

    let cards = [];

    // 1. Tenta a Recommendations API (melhor recomendação, mas exclui produtos R$ 0)
    try {
      const url = `/recommendations/products?section_id=bigmad-recommendations&product_id=${productId}&limit=${limit}`;
      const response = await fetch(url);
      if (response.ok) {
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const apiCards = doc.querySelectorAll('[data-bms-track] .bms-card');
        apiCards.forEach(c => cards.push(c));
      }
    } catch (e) {}

    // 2. Se faltam produtos (API filtrou os "sob consulta"), completa com a coleção
    if (cards.length < limit) {
      const collectionUrl = section.dataset.fallbackCollection;
      if (collectionUrl) {
        try {
          const url = `${collectionUrl}?section_id=bigmad-collection-fragment`;
          const response = await fetch(url);
          if (response.ok) {
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const collCards = doc.querySelectorAll('.bms-card');

            // Evita duplicar o produto atual e os que a API já trouxe
            const seen = new Set(cards.map(c => c.dataset.productId));
            seen.add(productId);

            collCards.forEach(c => {
              if (cards.length >= limit) return;
              const pid = c.dataset.productId;
              if (pid && !seen.has(pid)) {
                seen.add(pid);
                cards.push(c);
              }
            });
          }
        } catch (e) {}
      }
    }

    // 3. Renderiza o que conseguiu reunir
    if (cards.length > 0) {
      track.innerHTML = cards.map(c => c.outerHTML).join('');
      setupAddButtons(section);
      section.classList.add('is-visible');
      renderJudgemeBadges();
      setupCardVideos();
    } else {
      section.style.display = 'none';
    }
  }


  // ============================================
  // RENDER DE CARD (pro recently viewed — fallback, não usado atualmente)
  // ============================================
  function renderCard(p) {
    if (!p) return '';

    const onSale = p.compare_at_price && p.compare_at_price > p.price;
    const discount = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    const primary = p.featured_image ? imgUrl(p.featured_image, 600) : '';
    const secondary = p.images && p.images.length > 1 ? imgUrl(p.images[1], 600) : '';
    const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
    const available = p.available !== false;
    const url = `/products/${p.handle}`;

    return `
      <article class="bms-card${available ? '' : ' is-sold-out'}" data-product-id="${p.id}" data-product-url="${url}">
        <a href="${url}" class="bms-card-link" aria-label="${esc(p.title)}">
          <div class="bms-card-image-wrap">
            ${primary ? `<img class="bms-card-img bms-card-img--primary" src="${primary}" alt="${esc(p.title)}" loading="lazy">` : ''}
            ${secondary ? `<img class="bms-card-img bms-card-img--secondary" src="${secondary}" alt="" loading="lazy">` : ''}
            <div class="bms-card-badges">
              ${onSale ? `<span class="bms-badge bms-badge--discount">−${discount}%</span>` : ''}
              ${!available ? `<span class="bms-badge bms-badge--soldout">Esgotado</span>` : ''}
            </div>
            ${available && variantId ? `
              <button type="button" class="bms-card-add" data-bms-add
                data-product-handle="${p.handle}"
                data-variant-id="${variantId}"
                data-product-url="${url}"
                data-action="add"
                data-default-text="Adicionar"
                data-added-text="✓ Adicionado"
                aria-label="Adicionar">
                <span data-bms-add-text>Adicionar</span>
              </button>
            ` : ''}
          </div>
          <div class="bms-card-info">
            ${p.vendor ? `<p class="bms-card-vendor">${esc(p.vendor)}</p>` : ''}
            <h3 class="bms-card-title">${esc(p.title)}</h3>
            <div class="bms-card-stars">
              <div class="jdgm-widget jdgm-preview-badge" data-id="${p.id}"></div>
            </div>
            <div class="bms-card-price">
              <span class="bms-card-price-current">${money(p.price)}</span>
              ${onSale ? `<span class="bms-card-price-compare">${money(p.compare_at_price)}</span>` : ''}
            </div>
          </div>
        </a>
      </article>
    `;
  }

  function imgUrl(url, width) {
    if (!url) return '';
    // Shopify image URLs aceitam ?width=N
    if (url.includes('?')) {
      return url.split('?')[0] + `?width=${width}`;
    }
    return url + `?width=${width}`;
  }

  function esc(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  }

  // ============================================
  // NAVEGAÇÃO (setas)
  // ============================================
  function setupNavigation(section, track) {
    const prevBtn = section.querySelector('[data-bms-prev]');
    const nextBtn = section.querySelector('[data-bms-next]');

    function step() {
      const card = track.querySelector('.bms-card');
      if (!card) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '16');
      return card.getBoundingClientRect().width + gap;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    if (nextBtn) nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const max = track.scrollWidth - track.clientWidth - 5;
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // Espera DOM ter os cards e ajusta
    setTimeout(updateArrows, 200);

    // Reajusta depois de mutações (importante pro vistos recentemente)
    const observer = new MutationObserver(updateArrows);
    observer.observe(track, { childList: true });
  }

  // ============================================
  // SCROLL HORIZONTAL via wheel/trackpad
  // ============================================
  function setupWheelScroll(track) {
    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        track.scrollLeft += e.deltaX;
      }
    }, { passive: false });
  }

  // ============================================
  // ANIMAÇÃO DE ENTRADA
  // ============================================
  function setupAnimation(section) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            section.classList.add('is-visible');
            io.unobserve(section);
          }
        });
      }, { threshold: 0.15 });
      io.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  }

  // ============================================
  // BOTÕES "ADICIONAR"
  // ============================================
  function setupAddButtons(section) {
    section.querySelectorAll('[data-bms-add]').forEach(btn => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const action = btn.dataset.action;
        if (action === 'view') {
          window.location.href = btn.dataset.productUrl;
          return;
        }
        if (action === 'soldout') return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const textEl = btn.querySelector('[data-bms-add-text]');
        const defaultText = btn.dataset.defaultText || 'Adicionar';
        const addedText = btn.dataset.addedText || '✓ Adicionado';

        btn.disabled = true;
        if (textEl) textEl.textContent = '...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('fail');

          if (textEl) textEl.textContent = addedText;

          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bms' });
          }
          document.dispatchEvent(new CustomEvent('cart:added'));

          setTimeout(() => {
            if (textEl) textEl.textContent = defaultText;
            btn.disabled = false;
          }, 1800);
        } catch (err) {
          if (textEl) textEl.textContent = 'Tente novamente';
          setTimeout(() => {
            if (textEl) textEl.textContent = defaultText;
            btn.disabled = false;
          }, 1800);
        }
      });
    });
  }
})();
